export default __webpack_public_path__ + "static/media/town.5b436cd8.PNG";